import { render, staticRenderFns } from "./addEditor.dialog.vue?vue&type=template&id=26c32fe5&scoped=true"
import script from "./addEditor.dialog.vue?vue&type=script&lang=js"
export * from "./addEditor.dialog.vue?vue&type=script&lang=js"
import style0 from "./addEditor.dialog.vue?vue&type=style&index=0&id=26c32fe5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c32fe5",
  null
  
)

export default component.exports